/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import * as Yup from 'yup';

export const validationSchema = Yup.object({
  identifier: Yup.string().required('required').matches(/^\S*$/, 'no_spaces'),
  name: Yup.string().required('required'),
  description: Yup.string().required('required'),
  database: Yup.string().required('required'),
  schema: Yup.string().required('required'),
  rawSizeMb: Yup.number().typeError('number').required('required'),
  finalSizeMb: Yup.number().typeError('number').required('required'),
  importSizeMb: Yup.number().typeError('number').required('required'),
  categoryId: Yup.number().typeError('number').required('required'),
});

export const ignoreApiErrors: string[] = ['duplicate_identifier'];
